let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7DJxL")).then(() => parcelRequire('4bKh1'));